import { PROVINCES } from "../../lib/shop";

const Input = ({ k, label, f, set, required = true, wide, ...rest }) => (
  <div className={wide ? "sm:col-span-2" : ""}>
    <label className="label" htmlFor={k}>{label}</label>
    <input id={k} required={required} value={f[k]} onChange={set(k)} className="field" data-testid={`checkout-${k.replace(/_/g, "-")}-input`} {...rest} />
  </div>
);

const Province = ({ f, set, only }) => (
  <div>
    <label className="label" htmlFor="province">Province</label>
    <select id="province" required value={f.province} onChange={set("province")} className="field" data-testid="checkout-province-select">
      <option value="">Select province</option>{(only || PROVINCES).map((p) => <option key={p}>{p}</option>)}
    </select>
  </div>
);

export function DeliveryFields({ method, f, setF, set }) {
  if (!method) return <p className="text-sm text-zinc-400">Choose a delivery option above to enter your delivery details.</p>;
  if (method === "paxi") {
    return (
      <div className="grid sm:grid-cols-2 gap-4" data-testid="checkout-paxi-fields">
        <p className="sm:col-span-2 text-sm text-zinc-400">Tell us which PEP store you'll collect your order from with PAXI.</p>
        <Input k="pep_store" label="PEP store location" f={f} set={set} wide placeholder="e.g. PEP Soweto Maponya" />
        <Input k="mall_name" label="Mall / centre name" f={f} set={set} placeholder="e.g. Maponya Mall" />
        <Input k="city" label="City / Town" f={f} set={set} />
        <Province f={f} set={set} />
      </div>
    );
  }
  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid="checkout-address-fields">
      <Input k="street" label="Street address" f={f} set={set} wide autoComplete="street-address" />
      <Input k="suburb" label="Suburb" f={f} set={set} required={false} />
      <Input k="city" label="City / Town" f={f} set={set} />
      <Province f={f} set={set} only={method === "uber" ? ["Gauteng"] : null} />
      <Input k="postal_code" label="Postal code" f={f} set={set} inputMode="numeric" pattern="\d{4}" maxLength={4} />
      <div className="sm:col-span-2">
        <label className="label" htmlFor="instructions">Delivery instructions (optional)</label>
        <textarea id="instructions" rows={3} value={f.instructions} onChange={set("instructions")} className="field py-3" placeholder="Gate code, complex name, best time..." data-testid="checkout-instructions-input" />
      </div>
      {method === "uber" && (
        <label className="sm:col-span-2 flex gap-3 text-sm text-zinc-300 cursor-pointer">
          <input type="checkbox" required checked={f.within_area} onChange={(e) => setF({ ...f, within_area: e.target.checked })} className="accent-[#d4af37] w-5 h-5 shrink-0" data-testid="checkout-within-area-checkbox" />
          <span>I confirm my address is in Johannesburg, within 20km. (Outside this area? Choose PAXI instead.)</span>
        </label>
      )}
    </div>
  );
}

export function destinationText(c, method) {
  if (method === "paxi") return `PAXI collection at ${c.pep_store}, ${c.mall_name}, ${c.city}, ${c.province}${c.paxi_code ? ` (PAXI ${c.paxi_code})` : ""}`;
  return `${c.street}, ${c.suburb ? c.suburb + ", " : ""}${c.city}, ${c.province} ${c.postal_code}`;
}
